import { Col, Form, Input, Row, Tooltip } from "antd";
import { IconHelp } from "assets";
import PropTypes from "prop-types";
import React from "react";

import Tag from "components/common/Tag";

FormInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.string,
  optional: PropTypes.bool,
  rules: PropTypes.any,
  width: PropTypes.number,
  password: PropTypes.bool,
  error: PropTypes.string,
  allowClear: PropTypes.bool
};

function FormInput({
  label,
  name,
  helperText,
  optional,
  rules,
  width,
  password,
  error,
  allowClear,
  ...props
}) {
  return (
    <Row className="form-item form-input">
      <Col span={7} className="label">
        <h1 className="label">{label}</h1>
      </Col>
      <Col span={9}>
        <Form.Item validateTrigger={["onBlur", "onChange"]} rules={rules} name={name}>
          {password ? (
            <Input.Password
              allowClear={allowClear}
              {...props}
              status={error && "error"}
              className="input-password"
              size="large"
              variant="outlined"
              iconRender={(visible) => (visible ? "パスワードを非表示" : "パスワードを表示")}
              style={{ width: width && `${width}px` }}
            />
          ) : (
            <Input
              allowClear={allowClear}
              autoComplete="off"
              style={{ width: width && `${width}px` }}
              {...props}
            />
          )}
        </Form.Item>
        {error && <div className="error-msg">{error}</div>}
        {optional && <Tag type="optional" />}
        {helperText && (
          <Tooltip
            placement="bottomLeft"
            title={helperText}
            overlayStyle={{ maxWidth: "max-content" }}
            className="icon-help"
          >
            <IconHelp />
          </Tooltip>
        )}
      </Col>
    </Row>
  );
}

export default FormInput;
